import React from "react";
import "./ProfitCard.scss";
function ProfitCard({ target, balance, percentage, stage }) {
  return (
    <div className="profitCardMain border-2 border-border-darkNew rounded-lg p-4">
      <div className="flex justify-between gap-4">
        <div className="text-base">
          <div>Phase {stage}</div>
          <div className="text-xs text-white-opacity">
            Your Profit Target For This Challenge Is{" "}
            {target?.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 3,
            })}
          </div>
        </div>
        <div className="text-2xl font-N_Bold">
          {balance?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 3,
          })}
        </div>
      </div>
      <div>
        <progress
          value={percentage < 0 ? 0 : Number(percentage) / 100}
          className="w-full"
        />
      </div>
    </div>
  );
}
export default ProfitCard;
